import React, { PureComponent, Fragment } from 'react'
import { connect } from 'react-redux'
import mapSelectorsToProps from 'aria-viewer/core/selectors/mapSelectorsToProps'
import styleguide from 'aria-viewer/tour/constants/styleGuide'
import Icon from 'aria-viewer/tour/components/icon'
import Analytics from 'aria-viewer/analytics/utils/analytics'
import { ANALYTICS_ACTIONS } from 'aria-viewer/tour/constants/'
import SVG_LOGO from 'public/assets/svg/yv_logo.raw.svg'
import pure from 'recompose/pure'

const S = {
    containerStyle: (containerStyle, useResponsiveUI) => {
        let styleObj = {
            marginTop: 26,
            height: '1.7em',
            ...containerStyle,
        }
        return useResponsiveUI ? Object.assign(styleObj, { bottom: '8px' }) : styleObj
    },
    iconLogoStyle: {
        marginTop: '0.5em',
        width: '7em',
        height: '1.1em',
        backgroundSize: '100%',
        display: 'inline-block',
        verticalAlign: 'bottom',
    },
    poweredByStyle: poweredByStyle => {
        return {
            fontWeight: 'bold',
            fontSize: '0.8em',
            color: '#888',
            display: 'inline-block',
            ...poweredByStyle,
        }
    },
}

const YVLogo = pure(function YVLogo({ isSvg = false, svgLogoStyle }) {
    return isSvg ? (
        <div style={svgLogoStyle} className="yv_logo_black" dangerouslySetInnerHTML={{ __html: SVG_LOGO }} />
    ) : (
        <Icon icon="logo" style={S.iconLogoStyle} />
    )
})

class Logo extends PureComponent {
    static defaultProps = {
        style: {},
    }

    sendAnalytics = () => {
        Analytics.sendAnalytics(ANALYTICS_ACTIONS.POWEREDBY)
    }

    render() {
        const { useResponsiveUI } = this.props
        return (
            <div id="logo" style={S.containerStyle(this.props.containerStyle, this.props.useResponsiveUI)}>
                <a
                    onClick={this.sendAnalytics}
                    target="_blank"
                    href={'//youvisit.com?fromExperience=true' + (this.props.client.isClientApp ? '#yvexternal' : '')}
                    className={'accesibilityLastItem'}
                    alt="Open YouVisit.com"
                >
                    {!useResponsiveUI ? (
                        <Fragment>
                            <span style={S.poweredByStyle(this.props.poweredByStyle)}>Powered By</span>
                            <YVLogo isSvg={this.props.isSvg} svgLogoStyle={this.props.svgLogoStyle} alt="You Visit" />
                        </Fragment>
                    ) : (
                        <span style={S.poweredByStyle(this.props.poweredByStyle)}>Powered By YouVisit</span>
                    )}
                </a>
            </div>
        )
    }
}

export default connect(mapSelectorsToProps(['client']))(Logo)
